<template>
  <v-container fluid>
    <div v-if="!loading">
      <!-- Action Bar -->
      <div class="action-bar">
        <v-btn @click="beforeRoute" color="grey darken-1" outlined class="action-btn" small>
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>

        <div class="action-group">
          <v-btn @click="downloadQuotation(quote.quote_id)" color="primary" outlined class="action-btn" small>
            <v-icon left>mdi-printer</v-icon>
            Imprimir
          </v-btn>

          <v-btn v-if="hasFeature('SHOP-052')" v-show="quote.order_id == null" @click="updateChanges" color="success" outlined class="action-btn"
            small>
            <v-icon left>mdi-content-save</v-icon>
            Guardar Cambios
          </v-btn>

          <v-btn v-if="hasFeature('SHOP-052')" v-show="quote.order_id == null" @click="goToOrder" :loading="loading" color="orange darken-2" outlined
            class="action-btn" small>
            <v-icon left>mdi-receipt</v-icon>
            Convertir en Orden
          </v-btn>
        </div>
      </div>

      <!-- Main Content Card -->
      <v-card elevation="2">
        <v-row no-gutters>
          <!-- Document Section -->
          <v-col cols="12" md="12">
            <div class="document-container pa-2">
              <!-- Header -->
              <div class="document-header">
                <div class="header-content">
                  <h1 class="quotation-title">
                    COTIZACIÓN #{{ filLeft(quote.quote_id, 12, "0") }}
                  </h1>
                  <h2 class="business-title">{{ quote.bussines_unit_description }}</h2>
                </div>
                <div class="status-badge">
                  <v-chip :color="quote.order_id ? 'success' : 'warning'" dark label>
                    <v-icon left small>{{
                      quote.order_id ? "mdi-check" : "mdi-clock"
                      }}</v-icon>
                    {{ quote.order_id ? "Convertida" : "Pendiente" }}
                  </v-chip>
                </div>
              </div>
              <v-card outlined height="120px" style="background: #f8fafc;" class="mb-4">
                <v-container>
                  <v-row align="center" class="mt-2">
                    <v-col md="4" class="pr-0 py-2">
                      <span class="info-label">Orden:</span>
                      <v-hover v-slot="{ hover }">
                        <span @click="showOrder(quote.order_id, false)" class="info-value" :class="{
                          clickable: quote.order_id,
                          'hover-link': hover && quote.order_id,
                        }">
                          {{ quote.order_id || "Sin asignar" }}
                        </span>
                      </v-hover>
                    </v-col>
                    <v-col md="4" align="center" class="px-0 py-0">
                      <v-col md="8">
                      </v-col>
                    </v-col>
                    <v-col md="4" align="end" class="pl-0 py-0">
                      <span class="info-label">Creación: </span>
                      <span class="info-value">{{ getDate(quote.created_at) }}</span>
                    </v-col>

                  </v-row>
                  <v-row>
                    <v-col md="4" align="start" class="pr-0 py-0">
                      <span class="info-label">Proveedor: </span>
                      <span @click="viewEntity(quote.supplier_id)" class="info-value clickable supplier-link">
                        {{ quote.supplier_name }}
                      </span>
                    </v-col>
                    <v-col md="4" align="center" class="px-0 py-2">
                      <span class="info-label">Moneda: </span>
                      <v-btn-toggle v-model="selected_currencies" class="currency-toggle" mandatory color="primary"
                        dense>
                        <v-btn v-for="(item, i) of currencies" :key="i" :value="item.id"
                          :disabled="quote.order_id != null" x-small class="currency-btn">
                          {{ item.code }}
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <v-col md="4" align="end" class="pl-0 py-0">
                      <span class="footer-label">Solicitante: </span>
                      <span class="info-value">{{ quote.use_fullname }}</span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>


              <!-- Items Table -->
              <div class="table-container">
                <v-data-table :headers="headers" :items="quote.item_details" item-key="item.item_id"
                  class="document-table" hide-default-footer disable-pagination :items-per-page="-1">
                  <template v-slot:[`item.remove`]="{ item }">
                    <v-btn v-if="hasFeature('SHOP-052')" icon color="error" @click="remove_item(item)"><v-icon small>cancel</v-icon></v-btn>
                  </template>
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:[`item.item_code_supplier`]="{ item }">
                    <div class="code-cell">#{{ item.item_id }}</div>
                  </template>

                  <template v-slot:[`item.item_name`]="{ item }">
                    <div class="product-cell">
                      {{ item.item_name }}
                    </div>
                  </template>

                  <template v-slot:[`item.unit_name`]="{ item }">
                    <div class="unit-cell">
                      {{ item.unit_name }}
                    </div>
                  </template>

                  <template v-slot:[`item.tax_id`]="{ item }">
                    <v-select :readonly="quote.order_id != null" v-model="item.tax_id" :items="itbis" item-text="name"
                      item-value="id" class="tax-field" dense hide-details outlined @change="onTaxChange(item)" />
                  </template>

                  <template v-slot:[`item.price`]="{ item }">
                    <v-text-field :readonly="quote.order_id != null" v-model.number="item.price" type="number" min="0"
                      step="0.01" prefix="$" class="price-field" dense hide-details outlined />
                  </template>

                  <template v-slot:[`item.quotation_detail_quantity`]="{ item }">
                    <div class="quantity-cell">
                      {{ item.quotation_quantity }}
                    </div>
                  </template>

                  <template v-slot:[`item.discount`]="{ item }">
                    <v-text-field :readonly="quote.order_id != null" v-model.number="item.discount" type="number"
                      min="0" max="100" step="0.01" suffix="%" class="discount-field" dense hide-details outlined
                      @change="onDiscountChange(item)" />
                  </template>

                  <template v-slot:[`item.subtotal`]="{ item }">
                    <div class="subtotal-cell">
                      {{ currencyFormat(getItemSubtotal(item).toFixed(2)) }}
                    </div>
                  </template>

                  <template v-slot:[`item.tax_amount`]="{ item }">
                    <div class="tax-cell">
                      {{ currencyFormat(getItemTaxAmount(item).toFixed(2)) }}
                    </div>
                  </template>

                  <template v-slot:[`item.total`]="{ item }">
                    <div class="total-cell">
                      {{ currencyFormat(getItemTotalWithTax(item).toFixed(2)) }}
                    </div>
                  </template>
                </v-data-table>
              </div>
              <v-divider class="py-3"></v-divider>
              <v-row>
                <v-col md="6">
                  <div>
                    <div class="attachments-content">
                      <div v-if="selectedAttached === ''" class="upload-zone" @click="hasFeature('SHOP-052') ? takeImage() : null">
                        <div class="upload-area">
                          <v-icon size="60" color="grey darken-2" class="upload-icon">
                            mdi-cloud-upload
                          </v-icon>
                          <p class="upload-text">Haz clic para subir archivos</p>
                          <p class="upload-subtext">PDF, imágenes y documentos</p>
                        </div>
                      </div>

                      <div v-else class="file-viewer">
                        <iframe :src="selectedAttached" frameborder="0" class="file-frame"
                          title="Archivo adjunto de cotización" />
                        <div class="file-actions">
                          <v-btn v-if="hasFeature('SHOP-052')" @click="takeImage" color="primary" outlined small block>
                            <v-icon left small>mdi-plus</v-icon>
                            Subir Nuevo Archivo
                          </v-btn>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col md="6">
                  <div class="total-section">
                    <div class="totals-breakdown">
                      <div class="total-line">
                        <span class="total-label">Subtotal:</span>
                        <span class="total-amount">
                          {{ currencyFormat(totalSubtotal.toFixed(2)) }}
                          <span v-if="selected_currencies" class="currency-code">
                            {{
                              currencies.find(
                                (element) => element.id == selected_currencies
                              ).code
                            }}
                          </span>
                        </span>
                      </div>
                      <div class="total-line">
                        <span class="total-label">Descuentos:</span>
                        <span class="total-amount discount-amount">
                          {{ totalDiscounts > 0 ? '-' : '' }}{{ currencyFormat(totalDiscounts.toFixed(2)) }}
                          <span v-if="selected_currencies" class="currency-code">
                            {{
                              currencies.find(
                                (element) => element.id == selected_currencies
                              ).code
                            }}
                          </span>
                        </span>
                      </div>
                      <div class="total-line">
                        <span class="total-label">Impuestos:</span>
                        <span class="total-amount tax-amount">
                          {{ currencyFormat(totalTaxes.toFixed(2)) }}
                          <span v-if="selected_currencies" class="currency-code">
                            {{
                              currencies.find(
                                (element) => element.id == selected_currencies
                              ).code
                            }}
                          </span>
                        </span>
                      </div>
                      <div class="total-line final-total">
                        <span class="total-label">Total:</span>
                        <span class="total-amount">
                          {{ currencyFormat(total.toFixed(2)) }}
                          <span v-if="selected_currencies" class="currency-code">
                            {{
                              currencies.find(
                                (element) => element.id == selected_currencies
                              ).code
                            }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <DialogConfirm :showDialog="dialogConfirm" :confirm_settings="{
          title: title_remove_item,
          btn_affirmative: 'No, volver',
          btn_negative: 'Si, eliminar',
          icon: 'mdi-alert-circle',
          size: '45%',
        }" @closeDialog="confirm_remove_item"></DialogConfirm>
      </v-card>

      <!-- Hidden File Input -->
      <v-file-input v-show="false" ref="fileInput" @change="onFileChange" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" />
    </div>

    <!-- Loading State -->
    <div v-else class="loading-state">
      <v-progress-circular indeterminate color="primary" size="64" />
      <p class="loading-text">Cargando cotización...</p>
    </div>
  </v-container>
</template>

<script>
import moment from "moment";
import DialogConfirm from "@/components/DialogConfirm.vue";
import Warehouse from "@/views/Inventory/Warehouse.vue";
export default {
  components: { DialogConfirm },
  data() {
    return {
      storage_json: [],
      selected_currencies: null,
      selectedAttached: "",
      title_remove_item: "Seguro que desea eliminar este item?",
      dialogConfirm: false,
      loading: false,
      quote: {
        item_details: [],
      },
      headers: [
        { text: '', value: 'remove' },
        { text: '#', value: 'index' },
        {
          text: "CÓDIGO",
          value: "item_code_supplier",
          width: "10%",
          align: "start",
          sortable: false,
        },
        {
          text: "PRODUCTO/SERVICIO",
          align: "start",
          sortable: false,
          value: "item_name",
          width: "33%",
        },
        {
          text: "UNIDAD",
          value: "unit_name",
          width: "12%",
          align: "center",
          sortable: false,
        },
        {
          text: "ITBIS",
          value: "tax_id",
          width: "10%",
          align: "center",
          sortable: false,
        },
        {
          text: "PRECIO",
          value: "price",
          width: "12%",
          align: "center",
          sortable: false,
        },
        {
          text: "CANTIDAD",
          value: "quotation_detail_quantity",
          width: "8%",
          align: "center",
          sortable: false,
        },
        {
          text: "DESC %",
          value: "discount",
          width: "15%",
          align: "center",
          sortable: false,
        },

        {
          text: "TOTAL",
          value: "total",
          width: "12%",
          align: "right",
          sortable: false,
        },
      ],
      tot: 0,
    };
  },

  props: {
    currencies: {
      type: Array,
      required: true,
    },
    quotation_id: {
      type: String,
      required: true,
    },
    supplier_id: {
      type: String,
      required: true,
    },
    itbis: {
      type: Array,
      required: true,
    },
  },

  watch: {
    selected_currencies(newVal, oldVal) {
      // Solo ejecutar si ambos valores existen y son diferentes
      // y si los datos ya están cargados
      if (newVal && oldVal && newVal !== oldVal && this.quote.quote_id) {
        this.updateCurrencyQuote(newVal);
      }
    },
  },

  created() {
    this.getData();
  },

  computed: {
    totalSubtotal() {
      return (
        this.quote.item_details?.reduce((sum, item) => {
          return sum + this.getItemSubtotal(item);
        }, 0) || 0
      );
    },

    totalTaxes() {
      return (
        this.quote.item_details?.reduce((sum, item) => {
          return sum + this.getItemTaxAmount(item);
        }, 0) || 0
      );
    },

    totalDiscounts() {
      return (
        this.quote.item_details?.reduce((sum, item) => {
          const baseAmount = (item.price || 0) * (item.quotation_quantity || 0);
          const discountPercent = item.discount || 0;
          const discountAmount = baseAmount * (discountPercent / 100);
          return sum + discountAmount;
        }, 0) || 0
      );
    },

    total() {
      return (
        this.quote.item_details?.reduce((sum, item) => {
          return sum + this.getItemTotalWithTax(item);
        }, 0) || 0
      );
    },
  },

  methods: {
    formatN(number) {
      return number?.toFixed(2) || "0.00";
    },
    getItemSubtotal(item) {
      const baseAmount = (item.price || 0) * (item.quotation_quantity || 0);
      const discountPercent = item.discount || 0;
      const discountAmount = baseAmount * (discountPercent / 100);
      return baseAmount - discountAmount;
    },

    getItemTaxAmount(item) {
      const subtotal = this.getItemSubtotal(item);
      const taxRate = this.getTaxRate(item.tax_id);
      return subtotal * (taxRate / 100);
    },

    getItemTotalWithTax(item) {
      const subtotal = this.getItemSubtotal(item);
      const taxAmount = this.getItemTaxAmount(item);
      return subtotal + taxAmount;
    },

    getTaxRate(taxId) {
      const tax = this.itbis.find((t) => t.id === taxId);
      if (!tax) return 0;

      // Extraer el porcentaje del nombre del impuesto
      const match = tax.name.match(/(\d+)%/);
      return match ? parseInt(match[1]) : 0;
    },

    onTaxChange(item) {
      // Forzar reactividad usando Vue.set para asegurar que se detecte el cambio
      const index = this.quote.item_details.findIndex((detail) => detail === item);
      if (index !== -1) {
        this.$set(this.quote.item_details, index, { ...item });
      }
    },

    onDiscountChange(item) {
      // Forzar reactividad para los cambios de descuento
      const index = this.quote.item_details.findIndex((detail) => detail === item);
      if (index !== -1) {
        this.$set(this.quote.item_details, index, { ...item });
      }
    },

    async updateCurrencyQuote(currency) {
      // Verificar que tenemos todos los datos necesarios
      if (!currency || !this.quotation_id || !this.supplier_id) {
        return;
      }

      try {
        const data = {
          currency_id: currency,
          quotation_id: this.quotation_id,
          supplier_id: this.supplier_id,
        };

        const response = await this.api_Post(
          "shopping/update_currency_quote_supplier",
          data
        );
        const result = await response.json();

        if (response.status === 200) {
          this.$toast.success("Moneda actualizada");
          // Recargar datos sin disparar el watch nuevamente
          await this.getData();
        } else {
          this.$toast.error("Error al actualizar moneda");
          console.error("Error response:", result);
        }
      } catch (error) {
        this.$toast.error("Error de conexión");
        console.error("Update currency error:", error);
      }
    },

    downloadQuotation(id) {
      this.$router.push({
        name: "DownloadQuotation",
        params: {
          quotation_id: this.quotation_id,
          supplier_id: this.supplier_id,
        },
      });
    },

    async goToOrder() {
      this.loading = true;
      // const invalidItems = this.quote.item_details.filter(
      //   (item) => !item.price || item.price < 0
      // );

      try {
        const item_detail = this.quote.item_details.map((item) => ({
          item_id: item.item_id,
          request_id: item.request_id,
          price: item.price || 0,
          tax_id: item.tax_id || 1,
          discount: item.discount / 100 || 0,
          warehouse_id: item.warehouse_id || null,
          tax_id: item.tax_id || 1,
          quotation_quantity: item.quotation_quantity || 1,
          quantity: item.quotation_quantity || 1
        }));
        const response = await this.api_Post("shopping/convert_to_order", {
          order_id: null,
          request_id: parseInt(this.quote.request_id),
          quotation_id: this.quote.quotation_id,
          business_unit_id: this.quote.quote_business_unit_id,
          currency_id: this.quote.currency_id,
          location_id: this.quote.item_details[0].location_id,
          created_by: this.$store.state.auth.user.user.user_id,
          entity_id: this.quote.supplier_id,
          note: Array.from(
            new Map(
              this.quote.item_details.map(item => [item.request_id, item.comments?.[0]?.nota || ''])
            ).values()
          )
            .filter(nota => nota.trim() !== '')
            .join(', '),
          project: null,
          invoice_details: item_detail,
          status: null,
          credit_days_id: this.quote.credit_day_id
        });

        const data = await response.json();

        if (response.status === 200) {
          this.showOrder(data[0].id);
          this.loading = false;
        } else {
          this.loading = false;
          this.$toast.error(data.message);
        }
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.message);
      }
    },

    async updateChanges() {
      try {
        const data = this.quote.item_details.map((item) => ({
          item_id: item.item_id,
          price: item.price || 0,
          tax_id: item.tax_id || 1,
          discount: item.discount / 100 || 0,
        }));

        const response = await this.api_Post("shopping/update_price_quotation", {
          supplier_id: this.quote.supplier_id,
          quotation_id: this.quote.quotation_id,
          json: data,
        });

        if (response.status === 200) {
          this.$toast.success("Cambios guardados");
          this.getData();
        } else {
          this.$toast.error("Error al guardar");
        }
      } catch (error) {
        this.$toast.error("Error de conexión");
      }
    },

    async viewAddtached(item) {
      if (!item) return;

      try {
        if (item.key) {
          const resp = await fetch(this.spaces_file_url(item.key));
          const blob = await resp.blob();
          if (this.selectedAttached && this.selectedAttached.startsWith('blob:')) {
            URL.revokeObjectURL(this.selectedAttached);
          }
          this.selectedAttached = URL.createObjectURL(blob);
        } else {
          this.selectedAttached = '';
        }
      } catch (error) {
        console.error("Error loading attachment:", error);
      }
    },

    async getData() {
      this.loading = true;

      try {
        const response = await this.api_Post("shopping/quote_details", {
          quotation: this.quotation_id,
          supplier: this.supplier_id,
        });

        const data = await response.json();
        this.quote = data[0] || {};
        // Asignar valores por defecto para tax_id y discount si no existen
        if (this.quote.item_details) {
          this.quote.item_details.forEach((item) => {
            if (!item.tax_id) {
              item.tax_id = 1; // Excento 0% por defecto
            }
            if (!item.discount) {
              item.discount = 0; // Sin descuento por defecto
            } else {
              // Multiplicar por 100 para mostrar correctamente en la interfaz
              item.discount = item.discount * 100;
            }
          });
        }

        // Asignar la moneda DESPUÉS de cargar los datos
        // Esto evita que se dispare el watch prematuramente
        this.$nextTick(() => {
          this.selected_currencies = this.quote.currency_id;
        });

        if (this.quote.data_suppliers) {
          this.viewAddtached(this.quote.data_suppliers);
        }
      } catch (error) {
        this.$toast.error("Error al cargar cotización");
      } finally {
        this.loading = false;
      }
      if (this.quote.order_id == null) {
        this.headers[0].align = "start";
      } else {
        this.headers[0].align = " d-none";
      }
    },

    async onFileChange(file) {
      if (!file) return;

      try {
        const result = await this.upload_to_spaces(file, "quotes_atached");

        const response = await this.api_Post("shopping/attaches_quotes", {
          request_id: this.quote.request_id,
          quotation_id: this.quote.quote_id,
          supplier: this.quote.supplier_id,
          record: { url: result.url, key: result.key, name: file.name },
        });

        if (response.status === 200) {
          this.$toast.success("Archivo subido");
          await this.viewAddtached({ key: result.key, url: result.url });
        } else {
          this.$toast.error("Error al subir archivo");
        }
      } catch (error) {
        this.$toast.error(`Error: ${error.message}`);
      }
    },

    takeImage() {
      this.$refs.fileInput.$refs.input.click();
    },

    getDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    remove_item(item) {
      this.title_remove_item = `Seguro que desea eliminar el item ${item.item_name} (${item.item_id}) de la cotización?`;
      this.item_to_remove = item;
      this.dialogConfirm = true;
    },
    async confirm_remove_item(response) {
      if (response) {
        this.dialogConfirm = false;
        return
      }
      this.loading = true;
      try {
        const response = await this.api_Post("shopping/remove_item_quotation", {
          quotation_id: this.quote.quote_id,
          item_id: this.item_to_remove.item_id,
          supplier_id: this.quote.supplier_id,
        });
        if (response.status === 200) {
          this.$toast.success("Item eliminado correctamente!");
          this.getData();
        } else {
          this.$toast.error("Error al eliminar item");
        }
      } catch (error) {
        this.$toast.error("Error de conexión");
      } finally {
        this.loading = false;
        this.dialogConfirm = false;
      }
    }
  },
};
</script>
<style scoped>
/* Cambios principales para corregir problemas de zoom */

/* 1. Usar unidades más flexibles en lugar de px fijos */
.document-container {
  padding: 2.5rem 2rem;
  /* Cambiar de 40px a rem */
  background: white;
}

/* 2. Mejorar la flexibilidad del header */
.document-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0rem;
  /* Cambiar de 32px a rem */
  flex-wrap: wrap;
  gap: 1.25rem;
  /* Cambiar de 20px a rem */
  min-height: auto;
  /* Agregar para evitar colapsos */
}

.header-content {
  text-align: center;
  flex: 1;
  padding: 1rem 0;
  /* Cambiar de 16px a rem */
  min-width: 300px;
  /* Agregar ancho mínimo */
}

/* 3. Títulos más flexibles */
.quotation-title {
  font-size: clamp(1.20rem, 2vw, 1.3rem);
  /* Reducido de 1.5rem-2rem a 1.25rem-1.6rem */
  font-weight: 800;
  color: #2c3e50;
  margin: 0 0 0.75rem 0;
  letter-spacing: 0.125rem;
  /* Cambiar de 2px a rem */
  text-transform: uppercase;
}

.business-title {
  font-size: clamp(1.1rem, 3vw, 1.4rem);
  /* Usar clamp */
  font-weight: 600;
  color: #34495e;
  margin: 0;
  letter-spacing: 0.03125rem;
}

/* 4. Mejorar el contenedor de información */
.document-info {
  margin-bottom: 1.75rem;
  background: #f8fafc;
  border-radius: 0.375rem;
  padding: 1.25rem;
  border: 1px solid #e2e8f0;
}

.info-row {
  display: flex;
  align-items: end;
  margin-bottom: 0.75rem;
  gap: 0.625rem;
  min-height: 1.5rem;
  flex-wrap: wrap;
  /* Agregar para mejor adaptabilidad */
}

.info-label {
  font-weight: 700;
  color: #2c3e50;
  min-width: 5.3125rem;
  /* Cambiar de 85px a rem */
  font-size: 0.95rem;
  flex-shrink: 0;
  /* Evitar que se comprima */
}

/* 5. Mejorar la tabla para diferentes zooms */
.document-table {
  border: 1px solid #e0e0e0;
  border-radius: 0.25rem;
  overflow: auto;
  /* Cambiar a auto para scroll horizontal si necesario */
  width: 100%;
  min-width: 800px;
  /* Agregar ancho mínimo */
}

/* 6. Campos de entrada más flexibles */
.price-field {
  max-width: 8.75rem;
  /* Cambiar de 140px a rem */
  min-width: 7.5rem;
  /* Cambiar de 120px a rem */
}

.discount-field {
  max-width: 6.25rem;
  /* Cambiar de 100px a rem */
  min-width: 5rem;
}

/* 7. Contenedor de tabla con scroll horizontal */
.table-container {
  margin-bottom: 1.25rem;
  overflow-x: auto;
  /* Agregar scroll horizontal */
  -webkit-overflow-scrolling: touch;
  /* Mejor scroll en móviles */
}

/* 8. Footer más flexible */
.document-footer {
  border-top: 3px solid #34495e;
  padding-top: 1.5rem;
  margin-top: 2rem;
}

.totals-breakdown {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 1.25rem 1.875rem;
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5625rem rgba(102, 126, 234, 0.3);
  min-width: 17.5rem;
  /* Cambiar de 280px a rem */
  color: white;
}

/* 9. Mejorar responsive breakpoints */
@media (max-width: 75rem) {

  /* 1200px */
  .document-container {
    padding: 1.5rem 1.25rem;
  }

  .header-content {
    min-width: 250px;
  }

  .quotation-title {
    font-size: clamp(1.25rem, 3.5vw, 1.75rem);
  }
}

@media (max-width: 62.5rem) {

  /* 1000px */
  .document-header {
    flex-direction: column;
    text-align: center;
  }

  .info-label {
    min-width: auto;
  }

  .table-container {
    margin: 0 -1.25rem 1.25rem -1.25rem;
    /* Extender tabla en móviles */
  }
}

/* 10. Container principal más flexible */
.v-container.fluid {
  max-width: none;
  padding: 0.75rem;
}

.main-card {
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1);
  max-width: 100%;
}

/* 11. Action bar responsive */
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
  gap: 1rem;
  flex-wrap: wrap;
}

@media (max-width: 48rem) {

  /* 768px */
  .action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .action-group {
    justify-content: center;
  }
}

.info-section {
  padding: 0;
}

.info-value {
  color: #34495e;
  font-size: 0.80rem;
  font-weight: 500;
}

.info-value.clickable {
  color: #3498db;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
  transition: color 0.3s ease;
}

.info-value.hover-link {
  color: #2980b9;
}

.footer-label {
  font-weight: 700;
  color: #2c3e50;
  font-size: 1.1rem;
}

.footer-value {
  font-weight: 700;
  color: #34495e;
  font-size: 1.1rem;
}

.total-section {
  text-align: right;
}

.totals-breakdown {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  min-width: 280px;
  color: white;
}

.total-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 0;
}

.total-line:last-child {
  margin-bottom: 0;
}

.final-total {
  border-top: 2px solid rgba(255, 255, 255, 0.3);
  margin-top: 12px;
  padding-top: 12px;
  font-weight: 700;
}

.total-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
}

.total-amount {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
  font-family: "Arial", sans-serif;
}

.final-total .total-label {
  font-size: 1.3rem;
  font-weight: 800;
  color: white;
}

.final-total .total-amount {
  font-size: 1.5rem;
  font-weight: 800;
}

.tax-amount {
  color: #ffeaa7 !important;
}

.discount-amount {
  color: #00b894 !important;
}

.currency-code {
  font-size: 1.1rem;
  color: #7f8c8d;
  margin-left: 6px;
  font-weight: 700;
}

/* Attachments Section */
.attachments-section {
  background: #fafafa;
  border-left: 1px solid #e0e0e0;
  min-height: 100%;
}

.attachments-header {
  padding: 24px;
  border-bottom: 1px solid #e0e0e0;
  background: white;
}

.attachments-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #424242;
}

.attachments-content {
  padding: 14px;
  height: calc(100% - 80px);
  min-height: 400px;
}

.upload-zone {
  cursor: pointer;
  height: 100%;
  min-height: 300px;
}

.upload-area {
  border: 2px dashed #bdbdbd;
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  background: white;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f3f7ff;
}

.upload-icon {
  margin-bottom: 16px;
  transform: rotate(30deg);
}

.upload-text {
  font-weight: 600;
  color: #424242;
  margin: 0 0 8px 0;
  font-size: 1.1rem;
}

.upload-subtext {
  color: #757575;
  margin: 0;
  font-size: 0.9rem;
}

.file-viewer {
  height: 100%;
  min-height: 400px;
}

.file-frame {
  width: 100%;
  height: calc(100% - 60px);
  min-height: 350px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: white;
}

.file-actions {
  margin-top: 16px;
}

/* Loading State */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 20px;
}

.loading-text {
  font-size: 1.1rem;
  color: #757575;
  font-weight: 500;
  margin: 0;
}

.action-group {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.action-btn {
  text-transform: none;
  font-weight: 500;
  border-radius: 6px;
}
</style>
<!-- <style scoped>


.status-badge {
  flex-shrink: 0;
}

.header-divider {
  margin: 0 0 24px 0;
  border-color: #e0e0e0;
}

/* Document Info */
.document-info {
  margin-bottom: 28px;
  background: #f8fafc;
  border-radius: 6px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.info-section {
  padding: 0;
}



.info-label {
  font-weight: 700;
  color: #2c3e50;
  min-width: 85px;
  font-size: 0.95rem;
}



.supplier-link {
  font-weight: 700;
  color: #2980b9;
}

.currency-toggle {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.currency-btn {
  min-width: 45px;
  font-weight: 700;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
}

.section-divider {
  margin: 24px 0;
  border-color: #e0e0e0;
}

/* Table Container */
.table-container {
  margin-bottom: 20px;
}

.document-table {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.document-table >>> .v-data-table-header {
  background-color: #fafafa;
}

.document-table >>> .v-data-table-header th {
  font-weight: 700;
  color: #424242;
  border-bottom: 2px solid #e0e0e0;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
  padding: 12px 8px;
}

.document-table >>> tbody tr:hover {
  background-color: #f9f9f9;
}

.document-table >>> tbody td {
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 8px;
  vertical-align: middle;
}

/* Table Cells */
.code-cell {
  font-family: "Courier New", monospace;
  font-weight: 700;
  color: #2c3e50;
  background: #ecf0f1;
  padding: 6px 10px;
  border-radius: 4px;
  display: inline-block;
  font-size: 0.9rem;
  border: 1px solid #bdc3c7;
}

.product-cell {
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
  font-size: 0.95rem;
}

.unit-cell {
  text-align: center;
  color: #7f8c8d;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.8rem;
  background: #f8f9fa;
  padding: 4px 8px;
  border-radius: 3px;
  border: 1px solid #e9ecef;
}

.price-field {
  max-width: 140px;
  min-width: 120px;
}

.price-field >>> .v-input__control {
  min-height: 36px;
}

.price-field >>> .v-text-field__details {
  display: none;
}

.price-field >>> .v-text-field__slot input {
  font-weight: 600;
  text-align: center;
  font-size: 0.95rem;
  padding: 6px 10px;
}

.discount-field {
  max-width: 100px;
}

.discount-field >>> .v-input__control {
  min-height: 36px;
}

.discount-field >>> .v-text-field__details {
  display: none;
}

.discount-field >>> .v-text-field__slot input {
  font-weight: 600;
  text-align: center;
  font-size: 0.95rem;
  padding: 6px 10px;
}

.quantity-cell {
  text-align: center;
  font-weight: 700;
  color: white;
  background: #f39c12;
  padding: 6px 10px;
  border-radius: 4px;
  margin: 0 auto;
  display: inline-block;
  font-size: 0.9rem;
  min-width: 35px;
}

.subtotal-cell {
  text-align: right;
  font-weight: 600;
  color: #34495e;
  font-size: 0.95rem;
  font-family: "Arial", sans-serif;
}

.tax-cell {
  text-align: right;
  font-weight: 600;
  color: #e67e22;
  font-size: 0.95rem;
  font-family: "Arial", sans-serif;
}

.total-cell {
  text-align: right;
  font-weight: 800;
  color: #27ae60;
  font-size: 1.1rem;
  font-family: "Arial", sans-serif;
}

/* Document Footer */
.document-footer {
  border-top: 3px solid #34495e;
  padding-top: 24px;
  margin-top: 32px;
}

.requester-section {
  display: flex;
  align-items: center;
  gap: 12px;
}


/* Responsive Design */
@media (max-width: 1600px) {
  .document-container {
    padding: 24px 20px;
  }

  .document-header {
    flex-direction: column;
    text-align: center;
  }

  .quotation-title {
    font-size: 1.5rem;
  }

  .business-title {
    font-size: 1.1rem;
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .info-label {
    min-width: auto;
  }

  .total-box {
    flex-direction: column;
    gap: 8px;
  }

  .attachments-section {
    border-left: none;
    border-top: 1px solid #e0e0e0;
  }
}

@media (max-width: 1000px) {
  .quotation-detail {
    padding: 8px;
  }

  .action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .action-group {
    justify-content: center;
  }

  .document-container {
    padding: 16px 12px;
  }

  .attachments-content {
    padding: 16px;
  }
}
</style> -->
